module.exports = __webpack_public_path__ + "img/Logo-Horizontal-NoNeon.d7e9d7b8.svg";